import React from "react";
import {
  Button,
  Col,
  FormControl,
  FormLabel,
  Row,
  Table,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import { ConfigManager } from "../config/ConfigManager.js";
import {
  CustomerDetailsWithSalesInvoiceRequest,
  CustomerDetailsWithSalesInvoiceSearchCriteria,
} from "../ds/ds.js";
import {
  AlertToolBox,
  DatePickerComponent_adv,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import { isEmptyArray, isEmptyString, toDownloadReportAddress } from "../gui_components/Util.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupFabricStyleModule,
  PopupInvoiceModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class CustomerSalesOrderAndInvoiceDetails extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Customer SalesOrder and InvoiceDetails - Inquiry",
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowAlert: false,
      alertMsg: "",
      error_list: [],
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      criteria: new CustomerDetailsWithSalesInvoiceSearchCriteria(),
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      creditMemoTypes: [],
      creditTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCreditTypeList: true,
      isInquiryDatasFound: false,
      inquiryDataList: [],
      summaryData: null,
      isShowCreditMemoModule: false,
      moduleForPopup: [],
      isDisableFields: false,
      isShowCustomerModule: false,
      customerList: [],
      invoiceLineList: [],
      isShowFabricStyleModule: false,
      isShowInvoiceModule: false,
      isShowSalesModule: false,
      SalesOrderLineList: [],
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    const newDate = new Date(new Date().getFullYear(), 0, 1);
    const currentDay = new Date();
    criteria.fromDate = newDate;
    criteria.toDate = currentDay;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let creditMemoTypes = [];
    creditMemoTypes = attribute_cache.creditMemoTypes;
    if (!isEmptyArray(creditMemoTypes)) {
      this.state.creditMemoTypes = creditMemoTypes;
    }
    this.setState({ criteria: criteria });
  }
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearCriteria = () => {
    let criteria = new CustomerDetailsWithSalesInvoiceSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.setState({
      criteria: criteria,
      isDisableFields: false,
    });
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  resetInquiry = () => {
    let criteria = new CustomerDetailsWithSalesInvoiceSearchCriteria();
    criteria.companyCode = this.companyCode;
    const newDate = new Date(new Date().getFullYear(), 0, 1);
    const currentDay = new Date();
    criteria.fromDate = newDate;
    criteria.toDate = currentDay;
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isDisableFields: false,
      customerList: [],
      invoiceLineList: [],
      SalesOrderLineList: [],
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new CustomerDetailsWithSalesInvoiceRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      // if (
      //   SecurityAccessManager.CustomerSalesOrderAndInvoiceDetailReportInquiry_IsAccessible()
      // ) {
      ReportService.generateCustomerDetailsWithSalesInvoiceReport(
        listRequest,
        this.generateCreditmemoPageResponse,
        this.errorCallBack
      );
      // } else {
      //   this.inValidAccess(2);
      // }
    } else if (reportBean.reportType == 2) {
      // if (
      //   SecurityAccessManager.CustomerSalesOrderAndInvoiceDetailReportInquiry_IsAccessible()
      // ) {
      ReportService.generateCustomerDetailsWithSalesInvoiceReport(
        listRequest,
        this.generateCreditmemoPageResponseForExcel,
        this.errorCallBack
      );
      // } else {
      //   this.inValidAccess(3);
      // }
    }
  };
  generateCreditmemoPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          window.open(this.report_url + reportFilePath);
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateCreditmemoPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
       
        if (!isEmptyString(reportFilePath)) {
          window.open(downloadAddress, "_blank");
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    if (!isEmptyString(criteria.fromDate) && !isEmptyString(criteria.toDate)) {
      this.loadCustomerSalesList(criteria);
    } else {
      let errMsg = "";
      errMsg = "Enter Valid Date Range";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadCustomerSalesList = (criteria) => {
    // if (SecurityAccessManager.CustomerSalesOrderAndInvoiceDetailReportInquiry_IsAccessible()) {
    ReportService.inquireCustomerDetailsWithSalesInvoiceInfos(
      criteria,
      this.loadCustomerSalesListResponse,
      this.errorCallBack
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadCustomerSalesListResponse = (response) => {
    if (response.data != null && response.data.resultBean != null) {
      let criteria = this.state.criteria;
      let invoiceInfoDataList = [];
      let customerCodeList = [];
      let SalesOrderLineList = [];
      let invoiceLineList = [];
      if (!isEmptyArray(response.data.resultBean.infos)) {
        invoiceInfoDataList = response.data.resultBean.infos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      invoiceInfoDataList.map((code) => {
        customerCodeList.push(code.customerCode);
      });
      let temp = invoiceInfoDataList[0];
      criteria.customerCode = temp.customerCode;
      if (temp.invoiceInfos != null) {
        invoiceLineList = temp.invoiceInfos;
      } else if (temp.salesOrderInfos != null) {
        SalesOrderLineList = temp.salesOrderInfos;
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: invoiceInfoDataList,
        customerList: customerCodeList,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        invoiceLineList: invoiceLineList,
        SalesOrderLineList: SalesOrderLineList,
        criteria: criteria,
      });

      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  showDataOnChange = (e) => {
    let baseBean = this.state.criteria;
    let inquiryDataList = this.state.inquiryDataList;
    let invoiceLineList = [];
    let SalesOrderLineList = [];
    inquiryDataList.map((info) => {
      if (info.customerCode == e.target.value) {
        if (info.invoiceInfos != null) {
          invoiceLineList = info.invoiceInfos;
        } else if (info.salesOrderInfos != null) {
          SalesOrderLineList = info.salesOrderInfos;
        }
      }
    });
    baseBean.customerCode = e.target.value;
    this.setState({
      criteria: baseBean,
      invoiceLineList: invoiceLineList,
      SalesOrderLineList: SalesOrderLineList,
    });
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowFabricStyleModule: isOpen,
      isShowSalesModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesOrderCode = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  salesLineColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesOrder", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewSalesOrderCode, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "FabricStyle ",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Item Name" : "FabricStyle Name", "fabricStyleShortName", true)
        .setStyleDetails("left", "6", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sku", "skuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "orderUom", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Po#", "customerPONumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("invoice Qty", "openOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  invoiceLineColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "FabricStyle ",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Item Name" : "FabricStyle Name", "fabricStyleShortName", true)
        .setStyleDetails("left", "6", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sku", "skuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "orderUom", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Po#", "customerPONumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("invoice Qty", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  render() {
    let invoiceLineList = this.state.invoiceLineList;
    let customerList = this.state.customerList;
    let SalesOrderLineList = this.state.SalesOrderLineList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          onChange={this.onChange}
          creditTypeOnChange={this.creditTypeOnChange}
          creditTypeEnterKeyEvent={this.creditTypeEnterKeyEvent}
          displayCreditTypeAutoCompleteList={
            this.displayCreditTypeAutoCompleteList
          }
          creditMemoTypes={this.state.creditMemoTypes}
          customerList={this.state.customerList}
          showDataOnChange={this.showDataOnChange}
        />
        {this.state.isInquiryDatasFound && (
          <div className="div_inline">
            <div className="div_Equal_no_height">
               <div className="mt-3">
              <CustomTable
                data={SalesOrderLineList}
                columns={this.salesLineColumns()}
              />
            </div>
            </div>
            <div className="div_Equal_no_height">
               <div className="mt-3">
              <CustomTable
                data={invoiceLineList}
                columns={this.invoiceLineColumns()}
              />
            </div>
            </div>
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowSalesModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel10"}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
      </div>
    );
  }
}
class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      creditMemoTypes: this.props.creditMemoTypes,
    };
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  showDataOnChange = (e) => {
    this.props.showDataOnChange(e);
  };
  customerCodeOnChange = (e) => {
    this.props.customerCodeOnChange(e);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };
  displayAutoCompleteList = () => {
    this.props.displayAutoCompleteList();
  };
  creditTypeOnChange = (e) => {
    this.props.creditTypeOnChange(e);
  };
  creditTypeEnterKeyEvent = (e) => {
    this.props.creditTypeEnterKeyEvent(e);
  };
  displayCreditTypeAutoCompleteList = () => {
    this.props.displayCreditTypeAutoCompleteList();
  };
  render() {
    let criteria = this.props.criteria;
    let isDisableFields = this.props.isDisableFields;
    let customerList = this.props.customerList;
    let isInquiryDatasFound = this.props.isInquiryDatasFound;
    return (
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            <FormLabel>from Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="fromDate"
              onChange={this.onChange}
              value={criteria.fromDate}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>To Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="toDate"
              onChange={this.onChange}
              value={criteria.toDate}
              disabled={isDisableFields}
            />
          </Col>
          {this.props.isInquiryDatasFound && (
            <Col sm="1">
              <FormLabel>Customer</FormLabel>
            </Col>
          )}
          {this.props.isInquiryDatasFound && (
            <Col sm="2">
              <FormControl
                as="select"
                onChange={this.showDataOnChange}
                value={criteria.customerCode}
                name="customerCode"
              >
                {this.props.customerList.map((list, index) => (
                  <option key={index} value={list}>
                    {list}
                  </option>
                ))}
              </FormControl>
            </Col>
          )}
        </Row>
      </div>
    );
  }
}

function CustomerSalesOrderAndInvoiceDetailReport(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <CustomerSalesOrderAndInvoiceDetails {...props} name="" /> <br />
      </div>
    </div>
  );
}
export default CustomerSalesOrderAndInvoiceDetailReport;
